module.exports = __webpack_public_path__ + "static/media/MonitorParent-childWellCommunication-LR.799edba0.pdf";